<template>
  <div class="container-sm">
    <h5>Au sujet de mon Application</h5>
    <div>
    Cette Application a été réalisé avec pour objectif de transmettre au mieux les connaissances sur l'utilisation de la bibliothèque <span style="color:#0066FF;">Vue.js</span> et de son framework.
    </div>
    <br>
    Au cours de ce tutoriel, vous pourrez :
    <ul>
      <li>apprendre à utiliser la bibliothèque <span style="color:#0066FF;">Vue.js</span></li>
      <li>comprendre le système de réactivité de Vue.js</li>
      <li>utiliser des librairies tierces non réactives type <span style="color:#0066FF;">Leaflet</span></li>
      <li>intégrer la traduction à un site existant</li>
      <!-- <li>utiliser un framework graphique type vuetify</li> -->
      <li>appréhender l'architecture d'un projet front moderne</li>
      <li>CSS framework <span style="color:#0066FF;">Bootstrap</span></li>
    </ul>
  </div>
</template>
